"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Info = _interopRequireDefault(require("./Info"));
var _Form = _interopRequireDefault(require("./Form"));
var _SNETSignupModule = _interopRequireDefault(require("./SNETSignup.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SNETSignup = props => {
  const {
    info,
    onSubmit,
    signupError
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETSignupModule.default.signupContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: _SNETSignupModule.default.signupWrapper
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    className: _SNETSignupModule.default.signupInfo
  }, /*#__PURE__*/_react.default.createElement(_Info.default, info)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6
  }, /*#__PURE__*/_react.default.createElement(_Form.default, {
    onSubmit: onSubmit,
    signupError: signupError
  }))));
};
SNETSignup.propTypes = {
  info: _propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    list: _propTypes.default.arrayOf(_propTypes.default.string)
  }),
  onSubmit: _propTypes.default.func,
  signupError: _propTypes.default.string,
  resetSignupError: _propTypes.default.func
};
var _default = exports.default = SNETSignup;